import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import { ThemeProvider } from './contexts/ThemeContext';
import { AppRouter } from './routes';

console.log('[App.tsx] App component loading...');
console.log('[App.tsx] Store:', store.getState().auth);

export default function App() {
  console.log('[App.tsx] App component rendering...');

  return (
    <Provider store={store}>
      <PersistGate loading={<div>Rehydrating store...</div>} persistor={persistor}>
        <ThemeProvider>
          <AppRouter />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}
